import React, { useState } from 'react';
import { Dropdown } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLayerGroup,
  faGlobe,
  faMobileScreenButton,
  faTabletScreenButton,
  faChevronDown,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';
import {
  PlatformFilterButton,
  PlatformFilterChevron,
  PlatformDropdownContainer,
  PlatformOptionItem,
  PlatformOptionIcon,
  PlatformOptionLabel,
  PlatformCheckIcon,
} from './Styles';

export const PLATFORM_OPTIONS = [
  { value: 'all', label: 'All Platforms', icon: faLayerGroup },
  { value: 'web', label: 'Web', icon: faGlobe },
  { value: 'mobile', label: 'Mobile', icon: faMobileScreenButton },
  { value: 'kiosk', label: 'Kiosk', icon: faTabletScreenButton },
];

interface PlatformFilterDropdownProps {
  value: string;
  onChange: (value: string) => void;
}

const PlatformFilterDropdown: React.FC<PlatformFilterDropdownProps> = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selected = PLATFORM_OPTIONS.find((opt) => opt.value === value) || PLATFORM_OPTIONS[0];

  return (
    <Dropdown
      trigger={['click']}
      open={isOpen}
      onOpenChange={setIsOpen}
      dropdownRender={() => (
        <PlatformDropdownContainer>
          {PLATFORM_OPTIONS.map((opt) => {
            const isSelected = opt.value === value;
            return (
              <PlatformOptionItem
                key={opt.value}
                type="button"
                $selected={isSelected}
                onClick={() => {
                  onChange(opt.value);
                  setIsOpen(false);
                }}
              >
                <PlatformOptionIcon>
                  <FontAwesomeIcon icon={opt.icon} />
                </PlatformOptionIcon>
                <PlatformOptionLabel>{opt.label}</PlatformOptionLabel>
                {isSelected && (
                  <PlatformCheckIcon>
                    <FontAwesomeIcon icon={faCheck} />
                  </PlatformCheckIcon>
                )}
              </PlatformOptionItem>
            );
          })}
        </PlatformDropdownContainer>
      )}
    >
      <PlatformFilterButton type="button" onClick={(e) => e.preventDefault()}>
        <FontAwesomeIcon icon={selected.icon} style={{ fontSize: 13, opacity: 0.75 }} />
        {selected.label}
        <PlatformFilterChevron $open={isOpen}>
          <FontAwesomeIcon icon={faChevronDown} />
        </PlatformFilterChevron>
      </PlatformFilterButton>
    </Dropdown>
  );
};

export default PlatformFilterDropdown;
